import Parse from 'parse';

const authHelpers = {
    isAuthenticated: function() {
        if (Parse.User.current()) {
            return true 
        }
        return false         
    }, 

    logout: function() {
        Parse.User.logOut();
    }
    
}

export default authHelpers;


// WEBPACK FOOTER //
// ./src/components/auth/AuthHelpers.js